import React, { useState } from 'react'
import EditEventStyles from './AddBenefits.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';


  // import this for redux read write
  import { useSelector, useDispatch } from 'react-redux'
  import { setNotifications } from '../../state/GlobalState'
  import { setNotificationCount } from '../../state/GlobalState'
  import { fetchNotifications } from '../../state/GlobalState'

const AddBenefits = () => {
    const location = useLocation()
    const data = location.state
    console.log(data)

    const navigate = useNavigate()


     // get data from redux
     const name=useSelector((state)=>state.globalData.name);
     const count=useSelector((state)=>state.globalData.notificationCount);
     const dispatch =  useDispatch()



    const [eventData, setEventData] = useState({
        benefitsDesc: '',
        
    })

    const handleInputChange = (event) => {
        const {name, value} = event.target
        setEventData({ ...eventData, [name]: value })
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        try{
            const eventResponse = await axios.post(
                `${process.env.REACT_APP_STEELADMIN}/benefits/addBenefit`,
                eventData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            // console.log('Benefit Added.')
            // console.log(eventResponse)

            dispatch(fetchNotifications())
          
         dispatch(setNotificationCount({
          count:count+1,
         }))
         
       //   uptill here 

       
            alert('Benefit Added.')
            navigate('/benefits')

        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className={EditEventStyles.editEventMain}>
            <div className={EditEventStyles.editEventContent}>
                <form action="" className={EditEventStyles.editEventForm} onSubmit={handleSubmit}>
                    
                    <label className={EditEventStyles.editEventFormLabel}>Benefits</label>
                    <textarea className={EditEventStyles.editEventFormDesc} value={eventData.benefitsDesc} name='benefitsDesc' onChange={handleInputChange}/>
                   
                    <Button variant='contained' type='submit' className={EditEventStyles.saveChanges}>Save changes</Button>
                </form>
            </div>
        </div>
    )
}

export default AddBenefits